import React from "react";

const EtransferOptionsBus = (props) => {
  const options = [
    {
      text: 'Fonctions améliorées',
      handler: props.actionProvider.handleEufBus,
      id: 1
    },
    {
      text: 'J’ai de la difficulté avec une transaction en cours. Pouvez-vous m’aider?',
      handler: props.actionProvider.handleEtransferBus1,
      id: 2
    },
    {
      text: 'Puis-je utiliser Virement Interac pour mon entreprise?',
      handler: props.actionProvider.handleEtransferBus2,
      id: 3
    },
    {
      text: 'Quels types d’entreprises pourraient utiliser Virement INTERAC?',
      handler: props.actionProvider.handleEtransferBus3,
      id: 4
    },
    {
      text: 'Combien coûte l’envoi de fonds par Virement INTERAC?',
      handler: props.actionProvider.handleEtransferBus4,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransfer-products'>{optionsMarkup}</div>;
};

export default EtransferOptionsBus;